module.exports = __webpack_public_path__ + "img/SignOut.34793728.svg";